module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAO0lEQVQ4y2NgGBTgPxbwQlAXBWMDtDfg510xMKa9AejOhWFkA7BhrAbANOHCBA0gywUDH4gDn5CGNgAADkTs+jl/2eQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GG.png
// module id = 1146
// module chunks = 0